import { useState } from 'react';
import { featuredCategories, categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const [activeTab, setActiveTab] = useState('Featured');

  const tabs = ['Featured', 'All Categories'];

  const displayCategories = activeTab === 'Featured' ? featuredCategories : categories;

  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-primary-500 mb-3">
            <span className="w-1.5 h-1.5 bg-primary-500 rounded-full"></span>
            Trending Categories
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-4">
            Explore Popular Superbuy Spreadsheet Categories
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Browse through our organized product categories. Each category connects you directly to curated shopping resources on our main platform.
          </p>

          <div className="inline-flex items-center bg-background-100 rounded-full p-1 mt-6">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeTab === tab
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {activeTab === 'Featured' ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {displayCategories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group block relative aspect-[4/5] rounded-2xl overflow-hidden cursor-pointer"
              >
                <img
                  src={cat.imageUrl}
                  alt={`Superbuy Spreadsheet ${cat.name}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="text-background-50 font-heading font-semibold text-lg md:text-xl mb-1">
                    {cat.name}
                  </h3>
                  <p className="text-background-50/70 text-xs md:text-sm">
                    {cat.description}
                  </p>
                  <div className="flex items-center gap-1.5 mt-3 text-background-50/80 text-xs font-medium">
                    <span>Browse Category</span>
                    <i className="ri-arrow-right-up-line text-sm"></i>
                  </div>
                </div>
              </a>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {displayCategories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col items-center p-5 bg-background-100 rounded-xl hover:bg-primary-50 transition-all duration-200 cursor-pointer text-center"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-accent-100 rounded-xl mb-3 group-hover:bg-accent-200 transition-colors duration-200">
                  <i className="ri-shopping-bag-3-line text-accent-600 text-lg md:text-xl"></i>
                </div>
                <h4 className="text-foreground-900 font-semibold text-sm whitespace-nowrap">
                  {cat.name}
                </h4>
                <p className="text-foreground-400 text-xs mt-1 line-clamp-2">
                  {cat.description}
                </p>
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}